import { useState } from "react";
import { useAPI } from "../../apiv1";
import { Error as APIError } from "../../types/apiv1";
import ForgotCredentialsPageUI, { Feedback } from "../ui/ForgotCredentailsPageUI";

export default function NewAccountRecoveryRequest() {
	const api = useAPI();
	const [feedback, setFeedback] = useState<Feedback>();
	const [email, setEmail] = useState("");
	const [pending, setPending] = useState(false);

	async function submit() {
		setPending(true);
		try {
			await api.auth.forgot(email);
			setFeedback(Feedback.Accepted);
		} catch (e) {
			switch (e) {
			case APIError.BadRequest:
				setFeedback(Feedback.RejectedInvalidEmail);
				break;
			case APIError.Network:
				setFeedback(Feedback.RejectedNetwork);
				break;
			default:
				setFeedback(Feedback.RejectedBug);
			}
		} finally {
			setPending(false);
		}
	}

	return <ForgotCredentialsPageUI
		pending={pending}
		feedback={feedback}
		email={email} setEmail={setEmail}
		onSubmit={email !== "" ? submit : undefined}
	/>;
}
